import { render, staticRenderFns } from "./BaseStatusOrders.vue?vue&type=template&id=4166f03d&scoped=true"
import script from "./BaseStatusOrders.vue?vue&type=script&lang=js"
export * from "./BaseStatusOrders.vue?vue&type=script&lang=js"
import style0 from "./BaseStatusOrders.vue?vue&type=style&index=0&id=4166f03d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4166f03d",
  null
  
)

export default component.exports